import { IndicatorData } from "../../types/Indicator/IndicatorData";
import api from "../../utils/api";
import { INDICATOR_DATA_URL } from "../../utils/endpoints";

export async function getIndicatorData(
  dataPeriodId?: number,
  year?: number,
  partnerId?: number,
  frequencyId?: number,
) {
  try {
    const params = new URLSearchParams();

    if (dataPeriodId !== undefined) {
      params.append("DataPeriodId", dataPeriodId.toString());
    }
    if (year !== undefined) {
      params.append("Year", year.toString());
    }
    if (partnerId !== undefined) {
      params.append("PartnerId", partnerId.toString());
    }
    if (frequencyId !== undefined) {
      params.append("FrequencyId", frequencyId.toString());
    }

    const response = await api.get(
      `${INDICATOR_DATA_URL}?${params.toString()}`,
    );

    const data: IndicatorData[] = response.data.result.map(
      (option: IndicatorData) => ({
        id: option.id,
        county: option.county,
        province: option.province,
        frequency: option.frequency,
        dataPeriod: option.dataPeriod,
        year: option.year,
        indicator: option.indicator,
        value: option.value,
        state: option.state,
      }),
    );
    return data;
  } catch (error) {
    throw error;
  }
}
